import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { FamilyItem } from 'reactApp/modules/family/family.types';

export class GetFamilyAPICall extends APICallV4<FamilyItem[]> {
    _method = 'family/get';
    _type: Method = 'get';
    _retriesCount = 0;
}
